import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { GrowthPlan } from '@/components/admin/GrowthPlan';

export default function AdminGrowthPlan() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-10 py-8">
      <Button
        variant="ghost"
        onClick={() => navigate('/admin')}
        className="text-muted-foreground hover:text-white -ml-2 mb-4"
        data-testid="growth-back-btn"
      >
        <ArrowLeft className="w-4 h-4 mr-2" /> {t('admin.growth.back')}
      </Button>
      <GrowthPlan />
    </div>
  );
}
